module.exports = __webpack_public_path__ + "img/Lightning.84b2beb1.svg";